import React from 'react';

import { addStory } from 'lib/story-books';

import { ErrorText } from '.';

addStory('text-error', () => <ErrorText>ErrorText</ErrorText>);
